<div *ngIf="procedureCode" class="form">
    <h4>Procedure Code Form</h4>
    <mat-form-field appearance="fill">
        <mat-label>Name</mat-label>
        <input matInput [(ngModel)]="procedureCode.name" [disabled]="!createMode">
    </mat-form-field>
    <mat-form-field appearance="fill">
        <mat-label>Price</mat-label>
        <input matInput [(ngModel)]="procedureCode.units">
    </mat-form-field>
    <mat-form-field appearance="fill">
        <mat-label>Description</mat-label>
        <textarea matInput [(ngModel)]="procedureCode.description"></textarea>
    </mat-form-field>
    <div style="display: flex; justify-content: space-between;">
        <button mat-raised-button class="btn btn-primary" (click)="dialogRef.close(procedureCode)"
            [disabled]="!procedureCode.description"> Save</button> 
        <button mat-raised-button color="warn" (click)="dialogRef.close(null)"> Cancel</button>
    </div>
</div>